var React = require('react');

function DownloadCircle (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},".st0{fill:none;stroke:#00338D;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#00338D;stroke-width:0.9688;stroke-miterlimit:10;}"),React.createElement("polyline",{"points":"22,15.5 16,20.5 10,15.5 ","key":1}),React.createElement("line",{"x1":"9","y1":"23.5","x2":"23","y2":"23.5","key":2}),React.createElement("line",{"x1":"16","y1":"20.5","x2":"15.94","y2":"7.5","key":3}),React.createElement("circle",{"cx":"16","cy":"16","r":"15.5","key":4})]);
}

DownloadCircle.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 32 32","style":{"enableBackground":"new 0 0 32 32"},"xmlSpace":"preserve"};

module.exports = DownloadCircle;

DownloadCircle.default = DownloadCircle;
